import React from "react";
import { FaInfoCircle } from "react-icons/fa";

export default function InfoTooltip({ label, className = "" }) {
  if (!label) return null;

  return (
    <span
      className={`inline-flex items-center text-slate-400 hover:text-slate-600 ${className}`.trim()}
      title={label}
      aria-label={label}
      role="img"
    >
      <FaInfoCircle className="h-4 w-4" />
    </span>
  );
}
